export default __webpack_public_path__ + "static/media/7.d9cdd9e4.png";